import request from '../request'

//聊天框列表
export const ShopChatIndexRequest = p => {
    return request({
        method:'GET',
        url:'ShopChat/index',
        params: p
    })
}

//聊天框序列
export const ShopChatListRequest = () => {
    return request({
        method:'GET',
        url:'ShopChat/list'
    })
}

//添加聊天框
export const ShopChatAddRequest = d => {
    return request({
        method:'POST',
        url:'ShopChat/add',
        data: d
    })
}

//删除聊天框
export const ShopChatDelRequest = id => {
    return request({
        method:'DELETE',
        url:'ShopChat/del',
        data: {
            id: id
        }
    })
}

//修改聊天框
export const ShopChatEditRequest = data => {
    return request({
        method:'PUT',
        url:'ShopChat/edit',
        data
    })
}

//获取聊天框详情
export const ShopChatDetailsRequest = id => {
    return request({
        method:'GET',
        url:'ShopChat/details',
        params: {
            id
        }
    })
}